import { render, staticRenderFns } from "./FitModels.vue?vue&type=template&id=36b5ab28"
import script from "./FitModels.vue?vue&type=script&lang=js"
export * from "./FitModels.vue?vue&type=script&lang=js"
import style0 from "./FitModels.vue?vue&type=style&index=0&id=36b5ab28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports